import { createContext, useContext } from 'react';
import { AuthState, IAuthContext } from './types';

export const AuthContext = createContext<IAuthContext>({
	authState: AuthState.SignedOut,
	availableRoles: [],
	loadAvailableRoles: () => {},
	user: undefined,
	signIn: () => {},
	signOut: async () => {},
	refreshAuthState: () => {},
	setUser: () => {},
	sessionExpired: false,
	returnToLogin: () => {}
});

export const useAuthContext = (): IAuthContext => useContext(AuthContext);
